import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { BannerProps, TBannerSeverity } from './Banner.types';
import { TrevorIcon } from '../TrevorIcon';

const severityErrorCSSVars = css`
  --l-color: var(--color-feedback-error-darkest);
  --l-background: var(--color-feedback-error-lightest);
`;

const severityWarningCSSVars = css`
  --l-color: var(--color-feedback-warning-darkest);
  --l-background: var(--color-feedback-warning-lightest);
`;

const severitySuccessCSSVars = css`
  --l-color: var(--color-feedback-success-darkest);
  --l-background: var(--color-feedback-success-lightest);
`;

const severityInfoCSSVars = css`
  --l-color: var(--color-interface-secondary-normal);
  --l-background: var(--color-brand-blue2-lightest);
`;

const severityCssVars: Record<TBannerSeverity, FlattenSimpleInterpolation> = {
  error: severityErrorCSSVars,
  warning: severityWarningCSSVars,
  success: severitySuccessCSSVars,
  info: severityInfoCSSVars,
};

export const BannerContainer = styled.div<BannerProps>`
  ${(p) => severityCssVars[p.severity as TBannerSeverity]}
  padding: var(--spacing-l);
  border-radius: var(--radius-8);
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: var(--l-color);
  background: var(--l-background);
  display: flex;
  align-items: start;
  gap: var(--spacing-s);
  text-align: start;
  width: ${(p) => p.width ?? 'fit-content'};
  position: relative;

  > svg {
    flex-shrink: 0;
    margin-top: var(--spacing-xxs);
  }
`;

export const DropdownExpandIcon = styled(TrevorIcon).attrs({
  name: 'triangle-down',
}) <{ $expanded: boolean }>`
  margin-right: 0;
  transition-duration: var(--transition-fast);
  ${(p) =>
    p.$expanded &&
    css`
      transform: rotate(180deg);
    `};
`;

export const BannerExpandContent = styled.span`
  > ul {
    padding-left: var(--spacing-m);
    margin: unset;
  }
`;

export const BannerExpandLabel = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-s);
`;
